:host {
  display: block;
}


.JumpTabPanel {
  
  &__Content {    
    display: none;
    padding: 1rem 0;

    &.active {
      display: block;
    }
  }
}